import {DestroyRef, Directive, Input, TemplateRef, ViewContainerRef, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AuthService} from '@core/auth/auth.service';

@Directive({
  standalone: true,
  selector: '[hasAnyRole]',
})
export class HasAnyRoleDirective {
  private authorities: string[] = [];
  protected readonly templateRef = inject(TemplateRef<any>);
  protected readonly viewContainer = inject(ViewContainerRef);
  protected readonly authService = inject(AuthService);
  private readonly destroy: DestroyRef = inject(DestroyRef);

  @Input()
  set hasAnyRole(value: string | string[]) {
    this.authorities = typeof value === 'string' ? [<string>value] : <string[]>value;
    this.updateView();
    this.authService
      .getProfile()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((authenticated) => this.updateView());
  }

  private updateView(): void {
    this.viewContainer.clear();
    if (this.authService.hasAnyRole(this.authorities)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
